import { ChannelLink } from '../../../domain/value-objects/ChannelLink';
import { ChannelAdministrationRules } from '../../../domain/services/ChannelAdministrationRules';
import { normalizeChannelRules } from '../../../domain/entities/ChannelRule';
import { ChannelListParams } from '../../ports/IChannelRepository';
import { CreateAdminChannelInput, IAdminChannelRepository, UpdateAdminChannelInput } from '../../ports/IAdminChannelRepository';

export class ListAdminChannelsUseCase {
  constructor(private repo: IAdminChannelRepository) {}
  execute(params: ChannelListParams) {
    return this.repo.list(params);
  }
}

export class CreateAdminChannelUseCase {
  constructor(private repo: IAdminChannelRepository) {}
  execute(input: CreateAdminChannelInput) {
    const link = ChannelLink.create(input.link);
    return this.repo.create({
      ...input,
      link: link.Value,
      type: ChannelAdministrationRules.ensureType(input.type),
      membersCount: input.membersCount === undefined ? undefined : ChannelAdministrationRules.ensureMembersCount(input.membersCount),
      minimalSendingInterval: input.minimalSendingInterval === undefined ? undefined : ChannelAdministrationRules.ensureSendingInterval(input.minimalSendingInterval),
      isPrivate: input.isPrivate ?? link.isPrivate,
    });
  }
}

const ensureSendingWindow = (input: UpdateAdminChannelInput): Pick<UpdateAdminChannelInput, 'sendingStartTime' | 'sendingEndTime'> => {
  const { sendingStartTime, sendingEndTime } = input;
  if (sendingStartTime !== undefined && sendingEndTime !== undefined) {
    const window = ChannelAdministrationRules.ensureSendingWindow(sendingStartTime, sendingEndTime);
    return { sendingStartTime: window.start, sendingEndTime: window.end };
  }
  return {
    sendingStartTime: sendingStartTime === undefined ? undefined : ChannelAdministrationRules.ensureSendingTime(sendingStartTime),
    sendingEndTime: sendingEndTime === undefined ? undefined : ChannelAdministrationRules.ensureSendingTime(sendingEndTime),
  };
};

export class UpdateAdminChannelUseCase {
  constructor(private repo: IAdminChannelRepository) {}
  execute(uuid: string, input: UpdateAdminChannelInput) {
    return this.repo.update(uuid, {
      ...input,
      ...ensureSendingWindow(input),
      type: input.type === undefined ? undefined : ChannelAdministrationRules.ensureType(input.type),
      membersCount: input.membersCount === undefined ? undefined : ChannelAdministrationRules.ensureMembersCount(input.membersCount),
      minimalSendingInterval: input.minimalSendingInterval === undefined ? undefined : ChannelAdministrationRules.ensureSendingInterval(input.minimalSendingInterval),
      rules: input.rules === undefined ? undefined : normalizeChannelRules(input.rules),
    });
  }
}

export class CreateChannelCategoryUseCase {
  constructor(private repo: IAdminChannelRepository) {}
  execute(name: string) {
    return this.repo.createCategory(ChannelAdministrationRules.ensureCategoryName(name));
  }
}

export class RenameChannelCategoryUseCase {
  constructor(private repo: IAdminChannelRepository) {}
  execute(uuid: string, name: string) {
    return this.repo.renameCategory(uuid, ChannelAdministrationRules.ensureCategoryName(name));
  }
}
